import React from 'react'
import { Divider, Row, Form, Button, Input, Upload, Icon, Switch, notification } from 'antd'
import API from '../../services/API'
import Segment from '../../components/Segment'
import { Link } from 'react-router-dom'

const INIT = {
    name: '',
    description: '',
    active: true,
}

const MeasureUnitCreateContainer = ({ user }) => {
    const [data, setData] = React.useState(INIT)
    const [loading, setloading] = React.useState(false)
    const disabled = !data.name || !data.description

    const handleChange = (name, value) => {
        const newData = { ...data }
        newData[name] = value
        setData(newData)
    }

    const handleSubmit = e => {
        setloading(true)
        e.preventDefault()


        API.post('/api/measure_units', data)
            .then(() => {
                setloading(false)
                setData(INIT)
                notification.success({
                    message: 'La unidad de medida se ha guardado exitosamente',
                })
            })
            .catch(error => {
                setloading(false)
                notification.error({
                    message: 'Ha ocurrido un error al guarda la unidad de medida',
                })
            })
    }

    return (
        <Segment loading={loading}>
            <Divider>Unidad de medida</Divider>
            <Form style={{ maxWidth: '400px', margin: 'auto' }}>

                <p className="message">
                    Todos los campos marcados con un asterisco (<span>*</span>)
                    son campos obligatorios y deben ser llenados.
                </p>

                <Form.Item label="Nombre" hasFeedback>
                    <Input
                        placeholder="Escribe el nombre"
                        value={data.name}
                        onChange={e => {
                            handleChange('name', e.target.value)
                        }}
                    />
                </Form.Item>

                <Form.Item label="Descripción" hasFeedback>
                    <Input
                        placeholder="Escribe la descripcion"
                        value={data.description}
                        onChange={e => {
                            handleChange('description', e.target.value)
                        }}
                    />
                </Form.Item>

                <Form.Item label="Activo" hasFeedback>
                    <Switch
                        checked={!!data.active}
                        onChange={value => {
                            handleChange('active', value)
                        }}
                    />
                </Form.Item>

                <Row type="flex" justify="space-between" style={{ marginTop: '50px' }}>

                    <Form.Item>
                        <Link to="/measure_units">
                            <Button

                                icon="arrow-left"
                            >
                                Regresar
                            </Button>
                        </Link>
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            icon="save"
                            disabled={disabled}
                            onClick={handleSubmit}
                        >
                            Guardar
                        </Button>
                    </Form.Item>
                </Row>



            </Form>
        </Segment>
    )
}

export default MeasureUnitCreateContainer
